import { render, staticRenderFns } from "./ParametrosSistema.vue?vue&type=template&id=0446de17&"
import script from "./ParametrosSistema.vue?vue&type=script&lang=ts&"
export * from "./ParametrosSistema.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports